import React from "react";
import { TextField, TextFieldProps } from "@mui/material";
import { formatCNPJOrCPF, cleanDocument } from "@utils/cnpj";

type CnpjCpfFieldProps = Omit<TextFieldProps, "onChange" | "value"> & {
  value: string;
  onChange: (raw: string, formatted: string) => void;
  maxLength?: number;
};

const CnpjCpfField: React.FC<CnpjCpfFieldProps> = ({
  value,
  onChange,
  maxLength = 14,
  ...props
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = cleanDocument(e.target.value);
    if (raw.length <= maxLength) {
      onChange(raw, formatCNPJOrCPF(raw));
    }
  };

  return (
    <TextField
      {...props}
      variant="outlined"
      value={formatCNPJOrCPF(value)}
      onChange={handleChange}
      inputProps={{ maxLength: 18, ...props.inputProps }}
      fullWidth
    />
  );
};

export default CnpjCpfField;
